import React from "react";

export const UsersActionCard = ({ children }) => {
  return <div className="card_wrapper">{children}</div>;
};
